const translations = {
  translation: {
    appTitle: 'Unit Converter',
    appDescription: 'Convert units instantly across 11 different categories',
    selectCategory: 'Select a category',
    categories: {
      length: 'Length',
      mass: 'Mass',
      force: 'Force',
      energy: 'Energy',
      power: 'Power',
      pressure: 'Pressure',
      temperature: 'Temperature',
      time: 'Time',
      volume: 'Volume',
      angle: 'Angle',
      area: 'Area',
    },
    units: {
      // Length
      meter: 'Meter',
      kilometer: 'Kilometer',
      centimeter: 'Centimeter',
      millimeter: 'Millimeter',
      micrometer: 'Micrometer',
      nanometer: 'Nanometer',
      mile: 'Mile',
      yard: 'Yard',
      foot: 'Foot',
      inch: 'Inch',
      nauticalMile: 'Nautical Mile',
      // Mass
      kilogram: 'Kilogram',
      gram: 'Gram',
      milligram: 'Milligram',
      metricTon: 'Metric Ton',
      pound: 'Pound',
      ounce: 'Ounce',
      ton: 'US Ton',
      stone: 'Stone',
      // Force
      newton: 'Newton',
      kilonewton: 'Kilonewton',
      poundForce: 'Pound-force',
      kilopoundForce: 'Kilopound-force',
      dyne: 'Dyne',
      // Energy
      joule: 'Joule',
      kilojoule: 'Kilojoule',
      calorie: 'Calorie',
      kilocalorie: 'Kilocalorie',
      wattHour: 'Watt-hour',
      kilowattHour: 'Kilowatt-hour',
      electronvolt: 'Electronvolt',
      btu: 'BTU',
      footPound: 'Foot-pound',
      // Power
      watt: 'Watt',
      kilowatt: 'Kilowatt',
      megawatt: 'Megawatt',
      horsepower: 'Horsepower',
      btuPerHour: 'BTU/hour',
      // Pressure
      pascal: 'Pascal',
      kilopascal: 'Kilopascal',
      bar: 'Bar',
      atmosphere: 'Atmosphere',
      psi: 'PSI',
      torr: 'Torr',
      mmHg: 'mmHg',
      // Temperature
      celsius: 'Celsius',
      fahrenheit: 'Fahrenheit',
      kelvin: 'Kelvin',
      // Time
      second: 'Second',
      millisecond: 'Millisecond',
      microsecond: 'Microsecond',
      nanosecond: 'Nanosecond',
      minute: 'Minute',
      hour: 'Hour',
      day: 'Day',
      week: 'Week',
      month: 'Month',
      year: 'Year',
      // Volume
      liter: 'Liter',
      milliliter: 'Milliliter',
      cubicMeter: 'Cubic Meter',
      cubicCentimeter: 'Cubic Centimeter',
      gallon: 'Gallon',
      quart: 'Quart',
      pint: 'Pint',
      cup: 'Cup',
      fluidOunce: 'Fluid Ounce',
      tablespoon: 'Tablespoon',
      teaspoon: 'Teaspoon',
      // Angle
      degree: 'Degree',
      radian: 'Radian',
      gradian: 'Gradian',
      arcminute: 'Arcminute',
      arcsecond: 'Arcsecond',
      turn: 'Turn',
      // Area
      squareMeter: 'Square Meter',
      squareKilometer: 'Square Kilometer',
      squareCentimeter: 'Square Centimeter',
      squareMillimeter: 'Square Millimeter',
      hectare: 'Hectare',
      acre: 'Acre',
      squareMile: 'Square Mile',
      squareYard: 'Square Yard',
      squareFoot: 'Square Foot',
      squareInch: 'Square Inch',
    },
    from: 'From',
    to: 'To',
    enterValue: 'Enter value',
    result: 'Result',
  },
};

export default translations;
